module.exports = __webpack_public_path__ + "static/workonproject-eb2d400c89092794dfcf232199cf48fa.jpg";